'use strict';

var React = require('react');
var svtChannels = require('../../utils/channels.js');

class ChannelText extends React.Component {

	_isValidChannel(channel) {
		return channel && svtChannels[channel];
	}

	render() {
		var channel = this.props.channel;

		if (!this._isValidChannel(channel)) {
			return false;
		}

		var fullChannel = svtChannels[channel].name;

		return (
			<span>{fullChannel}</span>
		);
	}
}

ChannelText.displayName = 'ChannelText';
ChannelText.propTypes = {
	channel: React.PropTypes.string
};

module.exports = ChannelText;



/** WEBPACK FOOTER **
 ** ./app/components/elements/ChannelText.jsx
 **/